export type Category =
  | 'All'
  | 'Pants'
  | 'Blouses'
  | 'Shirts'
  | 'Jackets'
  | 'Dresses'
  | 'Tops'
  | 'Vests'
  | 'Corsets'
  | 'Skirts'

export interface Product {
  id: string
  name: string
  category: Category
  price: number
  description: string
  sizes: string[]
  image: string
  images?: string[]
  colors?: string[]
}

export const CATEGORIES: Category[] = [
  'All',
  'Dresses',
  'Blouses',
  'Shirts',
  'Pants',
  'Jackets',
  'Tops',
  'Vests',
  'Corsets',
  'Skirts',
]

export const PRODUCTS: Product[] = [
  {
    id: '40',
    name: 'Спідниця в складки',
    category: 'Skirts',
    price: 550,
    description:
      'Коротка спідниця в складки з габардину — гра у стилі преппі з дорослою елегантністю. Тримає форму, рухається легко та красиво. Чудово поєднується з корсетом, жилетом чи базовим топом. Доступна в чотирьох кольорах.',
    sizes: ['XS', 'S', 'M', 'L', 'XL'],
    colors: ['Чорний', 'Білий', 'Голубий', 'Бежевий'],
    image:
      'https://cdn.magicpatterns.com/uploads/tHL2iSDxYAxoQ6bjoiAu1N/photo_5305314355199023789_y.jpg',
    images: [
      'https://cdn.magicpatterns.com/uploads/tHL2iSDxYAxoQ6bjoiAu1N/photo_5305314355199023789_y.jpg',
      'https://cdn.magicpatterns.com/uploads/3RHZLnZixFT9q1yYBx9BcA/photo_5301161740299082089_y.jpg',
      'https://cdn.magicpatterns.com/uploads/aJ1VNaukSeUvgoCqRSMMt5/photo_5301161740299082091_y.jpg',
      'https://cdn.magicpatterns.com/uploads/ripuibHLg1GLLNdVkJPSqu/photo_5301161740299082090_y.jpg',
    ],
  },
  {
    id: '30',
    name: 'Майка в стилі бохо на бретелях',
    category: 'Tops',
    price: 600,
    description:
      'Романтична майка в стилі бохо з легкого струмливого шифону на тонких регульованих бретелях. Має глибокий V-подібний виріз, каскадні волани та подовжені асиметричні елементи, що ефектно спадають донизу. Чудово поєднується зі штанами палаццо чи джинсами. Доступна в чотирьох ніжних відтінках.',
    sizes: ['S', 'M', 'L'],
    colors: ['Білий', 'Коричневий', 'Рожевий', 'Голубий'],
    image:
      'https://cdn.magicpatterns.com/uploads/dFdPumXfcCvZtg2QqBn1Hw/photo_5305314355199023790_y.jpg',
    images: [
      'https://cdn.magicpatterns.com/uploads/dFdPumXfcCvZtg2QqBn1Hw/photo_5305314355199023790_y.jpg',
      'https://cdn.magicpatterns.com/uploads/tWT7cpyrF1jb6q5CkKDWTG/photo_5305314355199023791_y.jpg',
      'https://cdn.magicpatterns.com/uploads/rBcftAeN8cDK4zV9xabV5E/photo_5305314355199023792_y.jpg',
      'https://cdn.magicpatterns.com/uploads/6iyiUbEQpsYs4rxQkAcySf/photo_5301161740299082104_y.jpg',
      'https://cdn.magicpatterns.com/uploads/x8dTqo5WsDymUqGRYagaRs/photo_5301201206753564826_y.jpg',
      'https://cdn.magicpatterns.com/uploads/5EC8LaFU3WGRemWbZtEEN3/photo_5301201206753564823_y.jpg',
      'https://cdn.magicpatterns.com/uploads/62k9pUjbBWVP52Gwpig61W/photo_5301161740299082101_y.jpg',
    ],
  },
  {
    id: '15',
    name: 'Класичний жилет вільного крою',
    category: 'Vests',
    price: 550,
    description:
      'Класичний жилет вільного крою з V-подібним вирізом та застібкою на ґудзики. Універсальна базова річ, що легко поєднується з брюками, спідницею чи джинсами. Доступний у чорному та білому кольорах.',
    sizes: ['XS', 'S', 'M', 'L', 'XL'],
    colors: ['Чорний', 'Білий'],
    image:
      'https://cdn.magicpatterns.com/uploads/wukPzrmimUooozenx3Ng1W/photo_5301161740299082105_y.jpg',
    images: [
      'https://cdn.magicpatterns.com/uploads/wukPzrmimUooozenx3Ng1W/photo_5301161740299082105_y.jpg',
      'https://cdn.magicpatterns.com/uploads/8uMawBaPh3jYfskiYnQ2CF/photo_5301161740299082106_x.jpg',
      'https://cdn.magicpatterns.com/uploads/fxH2qtSonxnLQBrgGyF2zY/photo_5301161740299082107_y.jpg',
    ],
  },
  {
    id: '17',
    name: 'Корсет із габардину',
    category: 'Corsets',
    price: 650,
    description:
      'Елегантний корсет-топ із щільного габардину з відкритими плечима та застібкою на ґудзики спереду. Декоративні клапани кишень підкреслюють силует. Чудово поєднується з брюками чи спідницею. Доступний у чотирьох кольорах.',
    sizes: ['XS', 'S', 'M', 'L', 'XL'],
    colors: ['Чорний', 'Білий', 'Голубий', 'Бежевий'],
    image:
      'https://cdn.magicpatterns.com/uploads/8ippEn2Nr8hY6y4ybNCUxs/photo_5305314355199023786_y.jpg',
    images: [
      'https://cdn.magicpatterns.com/uploads/8ippEn2Nr8hY6y4ybNCUxs/photo_5305314355199023786_y.jpg',
      'https://cdn.magicpatterns.com/uploads/c1rHwNsp9qxuv97J1MaL5s/photo_5305314355199023787_y.jpg',
      'https://cdn.magicpatterns.com/uploads/hSMa2S39BxxKr8jEoxsMih/photo_5305314355199023788_y.jpg',
      'https://cdn.magicpatterns.com/uploads/srnnnzfhLVyKMEsG427we1/photo_5301161740299082098_y.jpg',
      'https://cdn.magicpatterns.com/uploads/kLkfKxfAkqbD7xfnzUpvQa/photo_5301161740299082099_y.jpg',
      'https://cdn.magicpatterns.com/uploads/pZoVMPpgbt8eaaMVMQbv5n/photo_5301161740299082084_y.jpg',
    ],
  },
  {
    id: '19',
    name: 'Сукня в стилі бохо',
    category: 'Dresses',
    price: 750,
    description:
      "Романтична сукня в стилі бохо з натуральної тканини прошва з делікатним перфорованим візерунком. Має глибокий V-подібний виріз із зав'язкою, об'ємні рукави-ліхтарики та еластичну талію, що підкреслює силует. Доступна у білому та чорному кольорах — ідеальний вибір для теплих літніх днів.",
    sizes: ['S', 'M', 'L'],
    image:
      'https://cdn.magicpatterns.com/uploads/2zB1omudYt9GU1w6aG6mVe/IMG_2373.png',
    images: [
      'https://cdn.magicpatterns.com/uploads/2zB1omudYt9GU1w6aG6mVe/IMG_2373.png',
      'https://cdn.magicpatterns.com/uploads/r3kfzEWZKq2GT5KrMhDApv/IMG_3154.png',
      'https://cdn.magicpatterns.com/uploads/9DRHV8WTHfyF6pvp6xUCGg/IMG_3151.png',
      'https://cdn.magicpatterns.com/uploads/eTeoYpqZVF5MnRAYGo1t2B/IMG_3150.png',
      'https://cdn.magicpatterns.com/uploads/8TkJEvps3rDonLGCVDr2JD/IMG_3156.png',
    ],
  },
  {
    id: '20',
    name: 'Сукня міні з мусліну',
    category: 'Dresses',
    price: 550,
    description:
      "Ніжна міні-сукня з натурального мусліну з відкритими плечима та об'ємними рукавами-ліхтариками. Має призбираний ліф із зав'язкою, вільний крій та грайливий волан по низу. Легка та дихаюча тканина ідеальна для теплої погоди. Доступна в кількох пастельних відтінках.",
    sizes: ['S', 'M'],
    image:
      'https://cdn.magicpatterns.com/uploads/2eNkdXcvb4NvsiMT2WSqAU/IMG_4831.png',
    images: [
      'https://cdn.magicpatterns.com/uploads/2eNkdXcvb4NvsiMT2WSqAU/IMG_4831.png',
      'https://cdn.magicpatterns.com/uploads/b18fpXpRrXDhpoQbSZLq9N/photo_5301161740299082166_y.jpg',
      'https://cdn.magicpatterns.com/uploads/ptgptHTAH5NtXkdm6APvh5/photo_5301161740299082167_y.jpg',
      'https://cdn.magicpatterns.com/uploads/7xNePGDQ94RNHHGXkKM2Ae/photo_5301161740299082164_y.jpg',
      'https://cdn.magicpatterns.com/uploads/ccTHaYi41VTjgfQCiuT3GU/photo_5301161740299082169_y.jpg',
      'https://cdn.magicpatterns.com/uploads/oPmJfCGxXG2ZMGL8ZWk5Jn/photo_5301161740299082168_y.jpg',
    ],
  },
  {
    id: '21',
    name: 'Блуза в стилі бохо',
    category: 'Blouses',
    price: 600,
    description:
      "Витончена напівпрозора блуза в стилі бохо з легкого струмливого шифону. Має романтичні волани вздовж глибокого вирізу із зав'язкою, об'ємні рукави та фігурні манжети. Універсальна річ, що чудово поєднується як зі штанами, так і зі спідницями. Доступна у п'яти кольорах.",
    sizes: ['S', 'M', 'L'],
    colors: ['Чорний', 'Молочний', 'Коричневий', 'Голубий', 'Рожевий'],
    image:
      'https://cdn.magicpatterns.com/uploads/qvRzcy7qxP2gNcY7PSmkRF/photo_5305314355199023505_y.jpg',
    images: [
      'https://cdn.magicpatterns.com/uploads/qvRzcy7qxP2gNcY7PSmkRF/photo_5305314355199023505_y.jpg',
      'https://cdn.magicpatterns.com/uploads/xgmyCCg7HzwwZJy5sFc9vT/photo_5305314355199023506_y.jpg',
      'https://cdn.magicpatterns.com/uploads/cPG8utGQk94i54yBJxtA4K/photo_5305314355199023507_y.jpg',
      'https://cdn.magicpatterns.com/uploads/f14xwJ7duZ1pmA3fx2uKQA/photo_5305314355199023508_y.jpg',
      'https://cdn.magicpatterns.com/uploads/nSxW7XpYTN2PZwgYxR7odW/photo_5305314355199023504_y.jpg',
      'https://cdn.magicpatterns.com/uploads/949fN4ynT7Sarq9z6Tkq3m/IMG_2679_(1).png',
      'https://cdn.magicpatterns.com/uploads/bArmfQvXKym91ctAv4no5X/photo_5301161740299082079_y.jpg',
      'https://cdn.magicpatterns.com/uploads/9bEcYw6oLrxTvQTeYtdVf6/photo_5301161740299082077_y.jpg',
      'https://cdn.magicpatterns.com/uploads/5sgtSCJGtseSJe5bx4cF4p/photo_5301161740299082078_y.jpg',
    ],
  },
  {
    id: '22',
    name: 'Сорочка картата в асортименті',
    category: 'Shirts',
    price: 550,
    description:
      "Затишна оверсайз сорочка з м'якої фланелі в класичну клітинку. Має вільний крій, накладну кишеню та комір на ґудзиках. Універсальна базова річ для багатошарових образів у прохолодну погоду. Доступна в асортименті розцвіток.",
    sizes: ['S', 'M', 'L'],
    colors: ['Коричнево-синя', 'Сіра', 'Чорно-біла', 'Коричнева'],
    image:
      'https://cdn.magicpatterns.com/uploads/oaXqbSect8KGhSGWy7ZvpD/photo_5301161740299082094_y.jpg',
    images: [
      'https://cdn.magicpatterns.com/uploads/oaXqbSect8KGhSGWy7ZvpD/photo_5301161740299082094_y.jpg',
      'https://cdn.magicpatterns.com/uploads/hXk8zZpAd4DHPKPCJ8492f/photo_5301161740299082095_y.jpg',
      'https://cdn.magicpatterns.com/uploads/7LMFxYdtMiJhBd2oYVjwr5/photo_5301161740299082096_y.jpg',
      'https://cdn.magicpatterns.com/uploads/h4xhoJXKLVWXfLbLWxAGZP/photo_5301161740299082097_y.jpg',
    ],
  },
  {
    id: '50',
    name: 'Штани палаццо',
    category: 'Pants',
    price: 600,
    description:
      'Широкі штани палаццо з натурального льону — легкі, дихаючі та неймовірно комфортні. Вільний крій струмливо спадає донизу, створюючи елегантний силует, а еластичний пояс на куліску забезпечує ідеальну посадку. Ідеальні для спекотних днів та літніх образів. Доступні в кількох ніжних відтінках.',
    sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
    colors: ['Білий', 'Молочний', 'Бежевий', 'Пудровий'],
    image:
      'https://cdn.magicpatterns.com/uploads/pxNiKQWBFWHGTriXmXeo5t/photo_5305314355199023509_y.jpg',
    images: [
      'https://cdn.magicpatterns.com/uploads/pxNiKQWBFWHGTriXmXeo5t/photo_5305314355199023509_y.jpg',
      'https://cdn.magicpatterns.com/uploads/7PrdtNv4dEFKVaoa8gnD5E/photo_5305314355199023510_y.jpg',
      'https://cdn.magicpatterns.com/uploads/xo34dJ1WQec61SS4suXo7a/photo_5305665339926452929_y.jpg',
      'https://cdn.magicpatterns.com/uploads/g9JewTng1v9iZRutuqnAQk/photo_5305665339926452930_y.jpg',
      'https://cdn.magicpatterns.com/uploads/6AnJHfpF4fv5EYafScjyfR/photo_5305665339926452927_y.jpg',
      'https://cdn.magicpatterns.com/uploads/1KvyPRcBYTkEpaQboWCtdG/photo_5305665339926452928_y.jpg',
      'https://cdn.magicpatterns.com/uploads/tYVfHFD6UwnCeYpMiK9FeP/photo_5305665339926452931_y.jpg',
    ],
  },
  {
    id: '23',
    name: 'Штани кльош від коліна зі шліцею',
    category: 'Pants',
    price: 600,
    description:
      'Елегантні штани кльош із розкльошуванням від коліна та витонченою шліцею знизу, що візуально подовжує ноги. Виготовлені зі щільного габардину, що тримає форму та має приємну гладку фактуру. Декоративний центральний шов спереду додає силуету структурованості. Універсальна модель для офісного чи вечірнього образу.',
    sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
    colors: ['Чорний', 'Коричневий', 'Молочний', 'Бежевий'],
    image:
      'https://cdn.magicpatterns.com/uploads/uNZLn1uZsg1osr7aRpJZyA/photo_5301161740299082071_y.jpg',
    images: [
      'https://cdn.magicpatterns.com/uploads/uNZLn1uZsg1osr7aRpJZyA/photo_5301161740299082071_y.jpg',
      'https://cdn.magicpatterns.com/uploads/timzFerTNYgWS4C4E6gQnZ/photo_5301161740299082072_y.jpg',
      'https://cdn.magicpatterns.com/uploads/hECygRrLezHuf5jysTGP3t/photo_5301161740299082073_y.jpg',
    ],
  },
  {
    id: '24',
    name: 'Штани вкорочена класика',
    category: 'Pants',
    price: 600,
    description:
      'Класичні вкорочені штани зі стрілками та високою посадкою. Виготовлені з якісного габардину, що тримає форму та має охайний матовий фінал. Лаконічний крій до щиколотки ідеально пасує як до підборів, так і до балеток. Незамінна базова річ для офісного гардеробу.',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
    colors: ['Чорний'],
    image:
      'https://cdn.magicpatterns.com/uploads/cXoLK895jdiZjQrkpocEUX/photo_5301161740299082074_y.jpg',
    images: [
      'https://cdn.magicpatterns.com/uploads/cXoLK895jdiZjQrkpocEUX/photo_5301161740299082074_y.jpg',
      'https://cdn.magicpatterns.com/uploads/i7ZyQmqYR9mrBNbDHWquHL/photo_5301161740299082075_y.jpg',
    ],
  },
  {
    id: '25',
    name: 'Штани палаццо без складок',
    category: 'Pants',
    price: 600,
    description:
      'Розкішні штани палаццо з широкими прямими штанинами без складок та гладким лаконічним кроєм. Висока посадка візуально подовжує силует, а щільний габардин чудово тримає форму. Елегантне рішення для повсякденних та святкових образів. Доступні у шести кольорах.',
    sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
    colors: ['Чорний', 'Коричневий', 'Молочний', 'Голубий', 'Бежевий', 'Сірий'],
    image:
      'https://cdn.magicpatterns.com/uploads/9XNZzYd3bQAVLgThkeMkmJ/photo_5301161740299082080_y.jpg',
    images: [
      'https://cdn.magicpatterns.com/uploads/9XNZzYd3bQAVLgThkeMkmJ/photo_5301161740299082080_y.jpg',
      'https://cdn.magicpatterns.com/uploads/17tDVWmzqaH7xvjpT4L4mc/photo_5301161740299082081_y.jpg',
      'https://cdn.magicpatterns.com/uploads/v64xhr54aEGgR2asBfUs2N/photo_5301161740299082082_y.jpg',
      'https://cdn.magicpatterns.com/uploads/nxSa83cvWCLtYypRM7XH6y/photo_5301161740299082083_y.jpg',
      'https://cdn.magicpatterns.com/uploads/mSVBkDDqiCebQFSxzQBJxB/photo_5301161740299082084_y.jpg',
    ],
  },
  {
    id: '26',
    name: 'Штани пряма класика, стандартна довжина',
    category: 'Pants',
    price: 600,
    description:
      'Класичні прямі штани стандартної довжини зі стрілками та високою посадкою. Виготовлені з якісного габардину, що тримає форму та має охайний матовий фінал. Прямий крій елегантно витягує силует і пасує до будь-якого взуття. Базова модель для офісного та повсякденного гардеробу.',
    sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
    colors: ['Чорний', 'Коричневий'],
    image:
      'https://cdn.magicpatterns.com/uploads/jXwctxN37De5442Z3KUDzX/photo_5301161740299082085_y.jpg',
  },
  {
    id: '27',
    name: 'Штани палаццо зі складками',
    category: 'Pants',
    price: 650,
    description:
      'Розкішні штани палаццо з елегантними закладеними складками спереду, що створюють вишуканий струмливий силует. Висока посадка та широкі штанини візуально подовжують ноги. Виготовлені зі щільного габардину, що бездоганно тримає форму. Ефектне рішення для святкових та офісних образів.',
    sizes: ['XS', 'S', 'M', 'L', 'XL'],
    colors: ['Чорний', 'Коричневий', 'Бежевий', 'Білий'],
    image:
      'https://cdn.magicpatterns.com/uploads/bFExvKaxZWvTXt57BuxMYr/photo_5305314355199023512_y.jpg',
    images: [
      'https://cdn.magicpatterns.com/uploads/bFExvKaxZWvTXt57BuxMYr/photo_5305314355199023512_y.jpg',
      'https://cdn.magicpatterns.com/uploads/1KpYK2RvuvVrCNmQXScDRV/photo_5305314355199023513_y.jpg',
      'https://cdn.magicpatterns.com/uploads/wnsL6o3272XsEzcNfCSoWd/photo_5305314355199023511_y.jpg',
      'https://cdn.magicpatterns.com/uploads/vuBduSG9WFEukLZiooWWsp/photo_5301161740299082087_y.jpg',
      'https://cdn.magicpatterns.com/uploads/tsW4i4F4XPMWYtgXJm7BHK/photo_5301161740299082088_y.jpg',
    ],
  },
  {
    id: '28',
    name: 'Жакет вкорочений двобортний',
    category: 'Jackets',
    price: 950,
    description:
      'Стильний вкорочений двобортний жакет із чітким структурованим кроєм та класичними лацканами. Виготовлений зі щільного габардину, що бездоганно тримає форму. Декоративні ґудзики додають образу акценту. Ідеально поєднується зі штанами палаццо для створення завершеного костюма.',
    sizes: ['S', 'M', 'L'],
    colors: ['Чорний', 'Білий', 'Коричневий'],
    image:
      'https://cdn.magicpatterns.com/uploads/xm2YiX3izDxJP4rku1o8tC/photo_5305314355199023500_y.jpg',
    images: [
      'https://cdn.magicpatterns.com/uploads/xm2YiX3izDxJP4rku1o8tC/photo_5305314355199023500_y.jpg',
      'https://cdn.magicpatterns.com/uploads/8o8L1dXek8gfNQszrCfNjV/photo_5305314355199023501_y.jpg',
      'https://cdn.magicpatterns.com/uploads/wu6GaDfgTZEhmawbUa6itw/photo_5305314355199023502_y.jpg',
      'https://cdn.magicpatterns.com/uploads/fXf2Wxjjhx2mWdGmgo542W/photo_5301161740299082066_y.jpg',
      'https://cdn.magicpatterns.com/uploads/9JbYYXFXvySwTqTLi5FiCo/photo_5301161740299082067_y.jpg',
      'https://cdn.magicpatterns.com/uploads/wqBfTiXtaPieCKZgR54ZLE/photo_5301161740299082070_y.jpg',
    ],
  },
  {
    id: '29',
    name: 'Класичний жакет приталеного силуету',
    category: 'Jackets',
    price: 1350,
    description:
      'Елегантний класичний жакет приталеного силуету з виразними вертикальними виточками, що підкреслюють талію. Виготовлений зі щільного габардину, що бездоганно тримає форму. Гострі лацкани та лаконічне застібання на ґудзики створюють вишуканий діловий образ. Універсальна основа капсульного гардеробу.',
    sizes: ['S', 'M'],
    image:
      'https://cdn.magicpatterns.com/uploads/3dEopsv1Bdmuh6GhQ4eVPP/photo_5301161740299082230_y.jpg',
    images: [
      'https://cdn.magicpatterns.com/uploads/3dEopsv1Bdmuh6GhQ4eVPP/photo_5301161740299082230_y.jpg',
      'https://cdn.magicpatterns.com/uploads/db1VPXKZJfgU7Kr4iHVP4k/photo_5301161740299082231_y.jpg',
      'https://cdn.magicpatterns.com/uploads/kqMyT2N9LpY2Ha1KEaxVGH/photo_5301161740299082232_y.jpg',
      'https://cdn.magicpatterns.com/uploads/9dTmp8DWx8xG98n1oTazW3/photo_5301161740299082233_y.jpg',
    ],
  },
]
